/**
 * @module icons
 * @description This module contains icon aliases and convenience components
 * to ensure consistent iconography for the application.
 */
import { Sparkles } from "lucide-react";

/**
 * @constant AIIcon the icon used for AI-related features.
 */
export const AIIcon = Sparkles;
